import {useEffect, useRef, useState} from 'react';

import {
  GameCenterHeaderModuleProps
} from "../../../widgets/game-center-widget/modules/game-center-header-module/models/game-center-header-module.props";
import {PRECISE_GAME_TIME} from "../../app/consts";

export class GameCenterHeaderModulePreciseGameTimeProps extends GameCenterHeaderModuleProps {
  minutes: Number;
  seconds: Number;
  countForward: Boolean;
  countBackward: Boolean;
  autoProgress: Boolean;
  statusText: String;
}

const toTotalSeconds = (minutes: Number, seconds: Number): Number => (minutes || 0) * 60 + (seconds || 0);

const toPreciseTimeString = (totalSeconds: Number): String => {
  const safeTotalSeconds = Math.max(totalSeconds, 0);

  return `${Math.floor(safeTotalSeconds / 60)}:${('' + (safeTotalSeconds % 60)).padStart(2, '0')}`;
};

export const PreciseGameTime = (props: GameCenterHeaderModulePreciseGameTimeProps) => {
  const {countForward, countBackward, autoProgress, statusText} = props;

  const direction: Number = countForward ? 1 : countBackward ? -1 : 0;
  const serverTotalSeconds: Number = toTotalSeconds(props.minutes, props.seconds);

  const [totalSeconds, setTotalSeconds] = useState(serverTotalSeconds);

  // the last time received from the server and the moment it arrived. progression is always
  // measured against this anchor, so the local clock can never drift away from the server time
  const anchorRef = useRef({totalSeconds: serverTotalSeconds, timestamp: Date.now()});
  const displayedRef = useRef(serverTotalSeconds);

  const applyTotalSeconds = (nextTotalSeconds: Number) => {
    displayedRef.current = nextTotalSeconds;
    setTotalSeconds(nextTotalSeconds);
  };

  const movesWithClock = (nextTotalSeconds: Number): Boolean =>
    direction * (nextTotalSeconds - displayedRef.current) >= 0;

  useEffect(() => {
    const isCorrection: Boolean =
      Math.abs(serverTotalSeconds - displayedRef.current) > PRECISE_GAME_TIME.SYNC_TOLERANCE_SECONDS;

    if (!autoProgress || isCorrection || movesWithClock(serverTotalSeconds)) {
      anchorRef.current = {totalSeconds: serverTotalSeconds, timestamp: Date.now()};
      applyTotalSeconds(serverTotalSeconds);
    }
  }, [serverTotalSeconds, direction, autoProgress]);

  useEffect(() => {
    if (!autoProgress || !direction) {
      return;
    }

    const intervalId = setInterval(() => {
      const {totalSeconds: anchorTotalSeconds, timestamp} = anchorRef.current;
      const elapsedSeconds = Math.floor((Date.now() - timestamp) / PRECISE_GAME_TIME.SECOND);
      const nextTotalSeconds = Math.max(anchorTotalSeconds + direction * elapsedSeconds, 0);

      if (movesWithClock(nextTotalSeconds)) {
        applyTotalSeconds(nextTotalSeconds);
      }
    }, PRECISE_GAME_TIME.SECOND);

    return () => clearInterval(intervalId);
  }, [autoProgress, direction]);

  return `${statusText ? statusText + ' ' : ''}${toPreciseTimeString(totalSeconds)}`;
};
